import { render, staticRenderFns } from "./WizardProgress.vue?vue&type=template&id=12a84d89&scoped=true"
import script from "./WizardProgress.vue?vue&type=script&lang=js"
export * from "./WizardProgress.vue?vue&type=script&lang=js"
import style0 from "./WizardProgress.vue?vue&type=style&index=0&id=12a84d89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a84d89",
  null
  
)

export default component.exports